import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { Id, EventRetrievalResponse } from "@planzone/dto";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  hasRetrievedEvent: boolean;
  event: EventRetrievalResponse;
  retrieveEvent(request: Boundaries["retrieveEvent"]["request"]): void;
}

function useRetrieveEvent(eventId: Id): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isRetrieveEventRequestPending(eventId),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isRetrieveEventRequestSuccess(eventId),
    ),
    isRequestFailure: useSelector(() =>
      selector.isRetrieveEventRequestFailure(eventId),
    ),
    hasRetrievedEvent: useSelector(() => selector.hasRetrievedEvent(eventId)),
    event: useSelector(() => selector.getEvent(eventId)),
    retrieveEvent: core.retrieveEvent,
  };
}

export { useRetrieveEvent };
